import React from 'react';
import { DsoAddressClient, DsoBillingAddressGroupClient } from 'types/dso/DsoCheckout.types';
import * as AddressStyled from '../AddressSearch/AddressSearch.styles';

export const displayAddress = (
  address: DsoAddressClient | undefined
): React.ReactNode => {
  if (!address) return null;
  return (
    <AddressStyled.AddressWrapper>
      {address.accountName && (
        <AddressStyled.AccountName>
          {address.accountName}{' '}
          <span style={{ fontWeight: 400, color: 'rgba(0, 0, 0, 0.55)' }}>({address.accountNumber})</span>
        </AddressStyled.AccountName>
      )}
      <AddressStyled.AccountAddress>{address.accountAddress}</AddressStyled.AccountAddress>
    </AddressStyled.AddressWrapper>
  );
};

export const getCommonBillingAddresses = (
  billingGroups: DsoBillingAddressGroupClient[] | undefined
): DsoAddressClient[] => {
  if (!billingGroups || billingGroups.length === 0) return [];
  const sets = billingGroups.map(
    g => new Set(g.billingAddresses.map(a => a.accountNumber))
  );
  const firstGroupNumbers = billingGroups[0].billingAddresses.map(a => a.accountNumber);
  const commonNumbers = firstGroupNumbers.filter(num =>
    sets.every(s => s.has(num))
  );
  return billingGroups[0].billingAddresses.filter(a =>
    commonNumbers.includes(a.accountNumber)
  );
};

export const areAllBillingAddressesSelected = (
  billingGroups: DsoBillingAddressGroupClient[] | undefined,
  selectedBillToAccountNumbers: Record<string, string>,
  isMultiShipOrder: boolean,
  selectedShipToAccountNumber: string | undefined
): boolean => {
  if (!billingGroups || billingGroups.length === 0) return false;

  if (isMultiShipOrder) {
    return billingGroups.every(
      group => !!selectedBillToAccountNumbers[group.shipAccountNumber]
    );
  }

  // Single-ship: only check billing for selected shipping address
  if (!selectedShipToAccountNumber) return false;
  return !!selectedBillToAccountNumbers[selectedShipToAccountNumber];
};
